// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/video-react/dist/video-react.css
 ** module id = 1203
 ** module chunks = 0
 **/